import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData, TextInput } from '../types'
import { CmsConverterService, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class DisclaimerConverter extends CmsConverterService<DisclaimerData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      text: formData.st_text ?? defaultTextInput,
      buttonText: formData.st_button_text ?? defaultTextInput
    }
  }
}

export const DISCLAIMER_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, DisclaimerData>>('DisclaimerConverter')

export interface DisclaimerData extends ConvertedComponentData {
  text: TextInput;
  buttonText: TextInput;
}
